import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Dropzone from 'react-dropzone'

class NewCertificationModal extends React.Component {
  state = {
    certificationId: 0,
    certificationTypeId: 0,
    providerCertificationId: "",
    userId: 0,
    issueDate: null,
    expirationDate: null,
    uploadedFile: []
  };

  componentWillMount() {
    window.addEventListener("openModalToAddCertificate", () => {
      this.openNewModal();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.certificationTypeId !== this.state.certificationTypeId || prevState.issueDate !== this.state.issueDate) {
      const certificationType = this.props.certificationTypes.find(c => c.id == +this.state.certificationTypeId);
      if (certificationType && certificationType.valid_for_duration && certificationType.valid_for_units && this.state.issueDate) {
        let issueDate = new Date(this.state.issueDate);
        let expirationDate;
        switch (certificationType.valid_for_units) {
          case 'days':
            expirationDate = new Date(issueDate.setDate(issueDate.getDate() + certificationType.valid_for_duration));
            break;
          case 'weeks':
            expirationDate = new Date(issueDate.setDate(issueDate.getDate() + certificationType.valid_for_duration * 7));
            break;
          case 'months':
            expirationDate = new Date(issueDate.setMonth(issueDate.getMonth() + certificationType.valid_for_duration));
            break;
          case 'years':
            expirationDate = new Date(issueDate.setFullYear(issueDate.getFullYear() + certificationType.valid_for_duration));
            break;
        }
        if (expirationDate) {
          $('#expirationDatePicker').data('kendoDatePicker').value(expirationDate);

          this.setState({
            expirationDate: expirationDate
          })
        }
      }
    }
  }

  saveCertification() {
    var that = this

    var formData = new FormData();
    formData.append('certification[certification_type_id]', that.state.certificationTypeId)
    formData.append('certification[user_id]', that.state.userId)

    if (that.state.issueDate) {
      formData.append('certification[issue_date]', that.state.issueDate)
    }

    formData.append('certification[expiration_date]', that.state.expirationDate)
    formData.append('certification[attachment]', that.state.uploadedFile)
    formData.append('certification[provider_certification_id]', that.state.providerCertificationId)

    var config = {
      headers: { 'content-type': 'multipart/form-data' }
    }

    axios.post(
      '/certifications',
      formData,
      config
    )
      .then(function (response) {
        $('#newCertificationModal').modal('hide')

        var employeesComboBox = $('#employees').data('kendoComboBox')
        employeesComboBox.value(null)

        var issueDatePicker = $('#issueDatePicker').data('kendoDatePicker')
        issueDatePicker.value(null)

        var expirationDatePicker = $('#expirationDatePicker').data('kendoDatePicker')
        expirationDatePicker.value(null)

        that.setState({
          certificationTypeId: 0,
          userId: 0,
          uploadedFile: []
        })

        that.props.onAdded(response.data);
      })
      .catch(function (error) {
        toastr.error('Certification not added')
        console.log(error)
      })
  }

  handleInputChange = e => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  };

  openNewModal() {
    var that = this

    var employeesComboBox = $('#employees').data('kendoComboBox')
    if (employeesComboBox) {
      employeesComboBox.value(null)
    }

    var issueDatePicker = $('#issueDatePicker').data('kendoDatePicker')

    if (issueDatePicker) {
      issueDatePicker.value(null)
    }

    var expirationDatePicker = $('#expirationDatePicker').data('kendoDatePicker')

    if (expirationDatePicker) {
      expirationDatePicker.value(null)
    }

    this.setState({
      uploadedFile: []
    })

    $('#newCertificationModal').modal('show')

    $('#newCertificationModal').on('hidden.bs.modal', function (e) {
      that.setState({
        certificationId: 0,
        certificationTypeId: 0,
        providerCertificationId: "",
        userId: 0,
        issueDate: null,
        expirationDate: null,
        uploadedFile: []
      })
    })

    $('#employees').kendoComboBox({
      placeholder: 'Search for an employee by name',
      dataTextField: 'full_name_reverse',
      dataValueField: 'id',
      filter: 'startswith',
      autoBind: false,
      PageSize: 20,
      change: function (e) {
        var value = e.sender.value()
        that.setState({
          userId: value
        })
      },
      dataSource: {
        type: 'json',
        serverFiltering: true,
        transport: {
          read: {
            url: '/users?search=true&archived=false',
            contentType: 'application/json; charset=utf-8',
            type: 'GET',
            dataType: 'json'
          }
        }
      }
    })

    $('#issueDatePicker').kendoDatePicker({
      change: function (e) {
        var value = e.sender.value()

        that.setState({
          issueDate: value
        })
      }
    })

    $('#expirationDatePicker').kendoDatePicker({
      change: function (e) {
        var value = e.sender.value()

        that.setState({
          expirationDate: value
        })
      }
    })
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles && acceptedFiles[0]) {
      toastr.success('Processing file...')

      this.setState({
        uploadedFile: acceptedFiles[0]
      })
    }

    if (rejectedFiles && rejectedFiles[0]) {
      toastr.error('File type not supported')
    }
  }

  renderFilePreview() {
    if (this.state.uploadedFile.preview && this.state.uploadedFile.type != 'application/pdf') {
      return (
        <div>
          <br />
          <img src={this.state.uploadedFile.preview} alt="Uploaded file preview" className='hidden-xs hidden-sm' height='125' />
          <img src={this.state.uploadedFile.preview} alt="Uploaded file preview" className='visible-xs visible-sm' height='50' />
        </div>
      )
    }
    else if (this.state.uploadedFile.preview && this.state.uploadedFile.type == 'application/pdf') {
      return (
        <div>
          <br />
          Attachment: {this.state.uploadedFile.name}
        </div>
      )
    }
    else {
      return (
        <span>
        </span>
      )
    }
  }

  renderSaveButton() {
    var that = this
    var valid = false

    if (this.state.certificationTypeId && this.state.userId && this.state.expirationDate) {
      valid = true
    }

    if (valid) {
      return (
        <button type='button'
          className='btn btn-pink full-width'
          onClick={function () { that.saveCertification() }}>
          SAVE
        </button>
      )
    }
    else {
      return (
        <button type='button'
          className='btn btn-pink full-width disabled'>
          SAVE
        </button>
      )
    }
  }

  render() {
    const certificationTypes = _.sortBy(this.props.certificationTypes, ['name']);

    var that = this
    var certificationTypeOptions = certificationTypes.map(function (certificationType) {
      return (
        <option key={certificationType.id}
          value={certificationType.id}>
          {certificationType.name}
        </option>
      )
    })

    return (
      <div className='modal fade'
        id='newCertificationModal'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'>
                <span aria-hidden='true'>
                  &times;
                </span>
              </button>
              <h1 className='modal-title'>
                New Certification
              </h1>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-xs-12 col-md-12'>
                  <label>
                    Certification *
                  </label>
                  <br />
                  <select className='form-control'
                    title='select certification type'
                    name='certificationTypeId'
                    value={this.state.certificationTypeId}
                    onChange={this.handleInputChange}>
                    <option value=''>
                      Select Certification
                    </option>
                    {certificationTypeOptions}
                  </select>
                </div>

                <div className='col-xs-12 col-md-12'>
                  <label htmlFor='new-cert-modal-provider-certification-id'>
                    Provider Certification ID
                  </label>
                  <br />
                  <input
                    className='form-control'
                    id='new-cert-modal-provider-certification-id'
                    name='providerCertificationId'
                    value={this.state.providerCertificationId}
                    onChange={this.handleInputChange}
                  />
                </div>

                <div className='col-xs-12 col-md-12'>
                  <label>
                    Employee *
                  </label>
                  <br />
                  <input id='employees' className='full-width' />
                  <br /><br />
                </div>
              </div>
              <div className='row'>
                <div className='col-xs-12 col-md-6'>
                  <label>
                    Issue Date
                  </label>
                  <br />
                  <input id='issueDatePicker'
                    placeholder='dd/mm/yyyy'
                    className='full-width' />
                </div>
                <div className='col-xs-12 col-md-6'>
                  <label>
                    Expiration Date *
                  </label>
                  <br />
                  <input id='expirationDatePicker'
                    placeholder='dd/mm/yyyy'
                    className='full-width' />
                </div>
              </div>
              <br />
              <label id="new-certification-attachment" className="control-label">Attachment(s)</label>
              <Dropzone
                name='new-certification-dropzone pointer-hand'
                className='dropzone dq-dropzone'
                acceptClassName='dq-dropzone-accepted'
                rejectClassName='dq-dropzone-rejected'
                accept='application/pdf, image/*'
                multiple={false}
                disablePreview={false}
                onDrop={function (acceptedFiles, rejectedFiles) { that.onDrop(acceptedFiles, rejectedFiles) }}
                inputProps={{'aria-labelledby': 'new-certification-attachment'}}
              >
                <center className='grey-text'>
                  <br />
                  <h4>Drop file here or click to upload.</h4>
                  <p>Only images and PDFs will be accepted.</p>
                  <br />
                </center>
              </Dropzone>
              {this.renderFilePreview()}
            </div>
            <div className='modal-footer'>
              {moment(this.state.issueDate).isAfter(moment(this.state.expirationDate)) ? (
                <p className='pink-text center-text'>
                  Check issue and expiration dates.
                </p>
              ) : (
                <span></span>
              )}
              {this.renderSaveButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewCertificationModal.propTypes = {
  certificationTypes: PropTypes.array,
  onAdded: PropTypes.func
}

export default NewCertificationModal
